export function getPublisher(vertical) {
  switch (vertical) {
    case 'msnbc':
      return {
        '@type': 'Organization',
        name: 'MSNBC',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.msnbc.com/sites/msnbc/themes/leanforward/images/site-header/msnbc-logo-small.png',
          width: 127,
          height: 23,
        },
      };

    case 'noticias':
      return {
        '@type': 'Organization',
        name: 'TELEMUNDO',
        logo: {
          '@type': 'ImageObject',
          url: 'https://sslnodeassets.nbcnews.com/cdnassets/projects/site-images/nbcnews-logo-white.png',
          width: 166,
          height: 24,
        },
      };

    case 'today':
      return {
        '@type': 'Organization',
        name: 'TODAY',
        logo: {
          '@type': 'ImageObject',
          url: 'https://nodeassets.today.com/cdnassets/today-images/today-logo.png',
          width: 167,
          height: 25,
        },
      };

    default:
      return {
        '@type': 'Organization',
        name: 'NBC News',
        logo: {
          '@type': 'ImageObject',
          url: 'https://sslnodeassets.nbcnews.com/cdnassets/projects/site-images/nbcnews-logo-white.png',
          width: 166,
          height: 24,
        },
      };
  }
}

const CREATORS = {
  today: 'TODAY.com',
  msnbc: 'MSNBC.com',
};

export function getCreator(vertical) {
  return CREATORS[vertical] || 'NBCNews.com';
}
